import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FilterColumn,
  FilterEvent,
  InventarioFilterEvent,
} from "src/app/models/filter";

@Component({
  selector: "app-inventario-filter",
  templateUrl: "./filter.component.html",
})
export class InventarioFilteromponent implements OnInit {
  public _filter = "";
  public _tipo = "Todos";
  public _ubicacion = "Todos";
  public _showInactive = false;
  public _columnsToSearch: string[] = [];
  @Input() public columns: FilterColumn[] = [];
  @Input() public ubicaciones: any[] = [];
  @Input() public tipos: any[] = [];
  @Input() public useActive: boolean = false;
  @Output() onSearch = new EventEmitter<InventarioFilterEvent>();
  constructor() {}

  ngOnInit(): void {}

  onFilter() {
    // this._columnsToSearch = this.columns
    //   .filter((f) => f.selected)
    //   .map((m) => m.property);

    this.onSearch.emit({
      filter: this._filter ?? "",
      tipo: this._tipo ?? "",
      ubicacion: this._ubicacion ?? "",
    });
  }
}
